import React, {Component} from 'react';
//import $ from "jquery";
import {AJAX, cross_form_errors, hidePreloader, showPreloader} from "../functions";
import Popup from "./Popup";
import AuthCodePopup from "./AuthCodePopup";
import Input from "../fields/Input";
import {showPopupWithGoBack} from "./PopupWithGoBack";

class LoginPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {email: '', errors: {}, popupPinCode: false/*, pinCode: '', hasErrorCode:false, errorCodeText: ''*/};

        this.handleCloseLP = this.handleCloseLP.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.handleActionSuccRequest = this.handleActionSuccRequest.bind(this);
    }

    handleCloseLP() {
        this.props.handleClose();
    }

    handleActionSuccRequest() {
        this.props.handleActionAfterSuccAuth();
        this.handleCloseLP();
    }
    // handleClosePinCodePopup() {
    //     this.setState({popupPinCode: false, pinCode: '', hasErrorCode:false, errorCodeText: ''})
    // }

    handleChangeInput(event) {
        this.setState({email: event.target.value.trim()});
    }

    // onChangePinCode(pinCode) {
    //     this.setState({ pinCode });
    // };

    sendEmail(event) {
        event.preventDefault();
        let t = this;

        if (t.state.email.length === 0)
            return false;

        let params = {
            email: t.state.email,
            action: 'api/booking/login'
        };
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1) {
                    t.setState({popupPinCode: true});
                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                    if (resp.errors !== undefined && resp.errors.form !== undefined) {
                        t.setState({errors: resp.errors.form});
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }


    render() {
        return (
            <Popup open={this.props.show}
                   modal
                   lockScroll
                   closeOnDocumentClick={false}
                   className={"bm-modal"}
            >
                <>
                    <button type="button" className="close" aria-label="Close" onClick={this.handleCloseLP}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="clearfix" />
                    <div className="col-12 text-center form-inputs">
                        <form onSubmit={this.sendEmail}>
                            <Input label={'Email'}
                                   placeholder={'Email'}
                                   name={'email'}
                                   value={this.state.email}
                                   hanldeChange={this.handleChangeInput}
                                   error={this.state.errors.email}
                                   autoFocus
                            />
                            <div className="d-flex justify-content-center align-items-center">
                                <input type="submit" className="go-btn go-submit" value=""/>
                            </div>
                        </form>

                        <AuthCodePopup showPopup={this.state.popupPinCode}
                                       email={this.state.email}
                                       handleClosePopup={()=>this.setState({popupPinCode: false})}
                                       handleSuccessfulRequest={this.handleActionSuccRequest}
                                       handleSendCode={this.sendEmail}
                        />
                    </div>
                </>
            </Popup>
        );
    }
}

export default LoginPopup;